import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUser, BUSINESS_UNIT_METADATA, BUSINESS_UNIT_TYPE, BusinessUnit, RANGER_FIREARM_ASSIGNMENT_LOG_TYPE, RANGER_METADATA, RANGER_TYPE, Ranger, RangerFirearmAssignmentLog, setDefaultLocationFromUser } from 'assets-model';
import { BusinessUnitService, RangerFirearmAssignmentLogService, RangerService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class RangerFirearmAssignmentLogItemComponentBase extends CrudItemComponent<RangerFirearmAssignmentLog, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  
  businessUnitSelectionList: BusinessUnit[];

  rangerSelectionList: Ranger[];


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected rangerFirearmAssignmentLogService: RangerFirearmAssignmentLogService,
    protected businessUnitService: BusinessUnitService,
    protected rangerService: RangerService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(RANGER_FIREARM_ASSIGNMENT_LOG_TYPE, fb, elementRef, router, route, userStorage, dialog, rangerFirearmAssignmentLogService, injector, snackbar);
  }

  createNewItem() {
    return new RangerFirearmAssignmentLog();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      rangerId: [null, []],
      businessUnit: [null, []],
      ranger: [null, []],
      currentFirearmCount: [null, []],
      firearmActionPendingCount: [null, []],
      rangerActionPendingCount: [null, []]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.rangerId?.disable();
    }
    this.businessUnit?.disable();
    this.ranger?.disable();
    this.currentFirearmCount?.disable();
    this.firearmActionPendingCount?.disable();
    this.rangerActionPendingCount?.disable();
  }
  
  
  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }
  
  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnitSelectionList = BUSINESS_UNIT_TYPE.entityDecorator.ensureContained(this.item && this.item.businessUnit, data.items);
      }
    );
  }

  
  businessUnitCompare(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }
  
  rangerDisplay(item: Ranger) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return RANGER_TYPE.description(item);
  }
  
  rangerLoadSelectionList() {
    this.rangerService.findAll().subscribe(
      data => {
        this.rangerSelectionList = RANGER_TYPE.entityDecorator.ensureContained(this.item && this.item.ranger, data.items);
      }
    );
  }

  
  rangerCompare(a: any, b: any) {
    return RANGER_METADATA.equals(a, b);
  }
  
  
  
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get rangerId() {
    return this.control('rangerId');
  }
  
  get businessUnit() {
    return this.control('businessUnit');
  }
  
  get ranger() {
    return this.control('ranger');
  }
  
  get currentFirearmCount() {
    return this.control('currentFirearmCount');
  }
  
  get firearmActionPendingCount() {
    return this.control('firearmActionPendingCount');
  }
  
  get rangerActionPendingCount() {
    return this.control('rangerActionPendingCount');
  }
  
}





